class ResponsiveVideo extends HTMLElement {
    desktopVideoPlayerSrc = ''
    mobileVideoPlayerSrc = ''

    constructor() {
        super();
    }

    connectedCallback() {
        this.deferredMediaDesktop = this.querySelector(
            ".video-section__media.deferred-media--desktop"
        );
        this.deferredMediaMobile = this.querySelector(
            ".video-section__media.deferred-media--mobile"
        );

        window.addEventListener(
            "DOMContentLoaded",
            this.toggleVideoPlaystate.bind(this)
        );
        window.addEventListener("resize", this.toggleVideoPlaystate.bind(this));
    }

    isIFramePlayer(player) {
        return player?.tagName === "IFRAME";
    }

    toggleVideoPlaystate() {
        // If autoplay option disabled, the videoplayer doesn't exist in the DOM
        const desktopVideoPlayer = this.querySelector(".video__desktop");
        const mobileVideoPlayer = this.querySelector(".video__mobile");
        const desktopVideoPlayerSourceNode = desktopVideoPlayer?.querySelector("source");
        const mobileVideoPlayerSourceNode = mobileVideoPlayer?.querySelector("source");

        this.desktopVideoPlayerSrc = desktopVideoPlayerSourceNode?.src || '';
        this.mobileVideoPlayerSrc = mobileVideoPlayerSourceNode?.src || '';

        if (mobileVideoPlayer || this.deferredMediaMobile) {

            if (window.screen.width < 750) {
                if (this.isIFramePlayer(mobileVideoPlayer)) {
                    this.controlVideo("pauseVideo", desktopVideoPlayer);
                    this.controlVideo("playVideo", mobileVideoPlayer);
                } else {
                    desktopVideoPlayer?.pause();

                    if (desktopVideoPlayerSourceNode) {
                        desktopVideoPlayerSourceNode.src = ''
                    }
                    if (mobileVideoPlayerSourceNode) {
                        mobileVideoPlayerSourceNode.src = this.mobileVideoPlayerSrc;
                    }

                    mobileVideoPlayer?.play();
                }

                this.deferredMediaMobile?.classList.remove("hidden");
                this.deferredMediaDesktop?.classList.add("hidden");
                mobileVideoPlayer?.classList.remove("hidden");
                desktopVideoPlayer?.classList.add("hidden");
            } else {
                if (this.isIFramePlayer(mobileVideoPlayer)) {
                    this.controlVideo("pauseVideo", mobileVideoPlayer);
                    this.controlVideo("playVideo", desktopVideoPlayer);
                } else {
                    mobileVideoPlayer?.pause();

                    if (mobileVideoPlayerSourceNode) {
                        mobileVideoPlayerSourceNode.src = ''
                    }
                    if (desktopVideoPlayerSourceNode) {
                        desktopVideoPlayerSourceNode.src = this.desktopVideoPlayerSrc;
                    }

                    desktopVideoPlayer?.play();
                }

                this.deferredMediaMobile?.classList.add("hidden");
                this.deferredMediaDesktop?.classList.remove("hidden");
                mobileVideoPlayer?.classList.add("hidden");
                desktopVideoPlayer?.classList.remove("hidden");
            }

        }
    }

    // action: "pauseVideo" | "stopVideo" | "playVideo"
    controlVideo(action, iframe) {
        iframe?.contentWindow.postMessage(
            '{"event":"command","func":"' + action + '","args":""}',
            "*"
        );
    }

    disconnectedCallback() {
        window.removeEventListener(
            "DOMContentLoaded",
            this.toggleVideoPlaystate.bind(this)
        );
        window.removeEventListener("resize", this.toggleVideoPlaystate.bind(this));
    }
}

customElements.define("responsive-video", ResponsiveVideo);
